import React from "react";

//import NextLink from 'next/link';
import { useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import useGlobalConfig from "../../../hooks/globalConfig";
import useTitle from "../../Seo/useTitle";
import MenuGeneralEmpresa from "./IntegratiosMenus/MenuGeneralEmpresa";
import MenuGeneralOperacion from "./IntegratiosMenus/MenuGeneralOperacion";
import MenuGeneralBodega from "./IntegratiosMenus/MenuGeneralBodega";
import MenuGeneralMyAcount from "./IntegratiosMenus/MenuGeneralMyAcount";
import MenuFalabella from "./IntegratiosMenus/MenuFalabella";
import SuperAdminMenu from "./AsministratorsMenus/SuperAdminMenu";
import MenuAdministartosFinance from "./AsministratorsMenus/MenuAdministartosFinance";
export const DashboardSidebar = (props) => {
  const { img5 } = useGlobalConfig();

  const { siteName } = useGlobalConfig();
  useTitle({ title: `${siteName} Dashboard` });

  //assigning location variable
  const location = useLocation();

  //destructuring pathname from location
  // const { pathname } = location;

  //Javascript split method to get the name of the path in array
  // const splitLocation = pathname.split("/");

  return (
    <div className="sidebar-body">
      <div id="brandsLogo">
        <Box
          component="img"
          src={img5}
          alt="logo"
          sx={{
            height: "auto",
            maxWidth: "100px",
            backgroundColor: "#fff",
            borderRadius: "100%",
          }}
        />
      </div>
      <h3 className="btn-sidebarLink alignItemscentertitle">
        Super Administrador Ebiex
      </h3>
      {props.userDataContext.uid === process.env.REACT_APP_SUPERADMIN ? (
        <SuperAdminMenu onNavigate={props.onNavigate}></SuperAdminMenu>
      ) : null}

      <MenuGeneralMyAcount onNavigate={props.onNavigate}></MenuGeneralMyAcount>
      <MenuGeneralEmpresa onNavigate={props.onNavigate}></MenuGeneralEmpresa>
      <MenuGeneralOperacion
        key={"alt1"}
        onNavigate={props.onNavigate}
      ></MenuGeneralOperacion>
      {/* {props.companyCollaborator ? (
        <>
          {Array.isArray(props.companyCollaborator) &&
          props.companyCollaborator.length > 0
            ? props.companyCollaborator.map((item, index) => {
                if (item !== "falabella") {
                  return (
                    <MenuGeneralOperacion
                      key={index}
                      onNavigate={props.onNavigate}
                    ></MenuGeneralOperacion>
                  );
                }
                return null;
              })
            : 
            props.companyCollaborator !== "falabella" && (
                <MenuGeneralOperacion
                  onNavigate={props.onNavigate}
                ></MenuGeneralOperacion>
              )
              }
        </>
      ) : null} */}

      <MenuGeneralBodega onNavigate={props.onNavigate}></MenuGeneralBodega>
      {props.companyCollaborator ? (
        <>
          {Array.isArray(props.companyCollaborator) &&
          props.companyCollaborator.length > 0
            ? props.companyCollaborator.map((item, index) => {
                if (item === "falabella") {
                  return (
                    <MenuFalabella
                      key={index}
                      companyCollaborator={item}
                      onNavigate={props.onNavigate}
                    ></MenuFalabella>
                  );
                }
                return null;
              })
            : props.companyCollaborator === "falabella" && (
                <MenuFalabella
                  key={props.companyCollaborator}
                  companyCollaborator={props.companyCollaborator}
                  onNavigate={props.onNavigate}
                ></MenuFalabella>
              )}
        </>
      ) : null}
      {props.userDataContext.uid === process.env.REACT_APP_SUPERADMIN ? (
        <MenuAdministartosFinance
          companyCollaborator={props.companyCollaborator}
          companyRole={props.companyRole}
          isSuperAdmin={
            props.userDataContext.uid === process.env.REACT_APP_SUPERADMIN
              ? true
              : false
          }
          onNavigate={props.onNavigate}
        ></MenuAdministartosFinance>
      ) : null}
    </div>
  );
};
